import React from 'react';
import { connect } from 'react-redux';
import { fullScreen, regularScreen } from '../../../actions/fullscreen';

export class FullscreenBtn extends React.Component {
	onClick = () => {
		if (this.props.fullscreen.fullscreen === true) {
	      this.props.regularScreen();
	    } else if (this.props.fullscreen.fullscreen === false) {
	      this.props.fullScreen();
	    }
	}
	render() {
    	return (
    		<button id="fullscreen-btn" title="Fullscreen button" onClick={this.onClick} className="header-btn"></button>
    	)
  	}
}

const mapStateToProps = function(state){
	return {
    	fullscreen: state.fullscreen
  	}
}

const mapDispatchToProps = (dispatch) => ({
	fullScreen: () => dispatch(fullScreen()),
	regularScreen: () => dispatch(regularScreen())
});

export default connect(mapStateToProps, mapDispatchToProps)(FullscreenBtn);


// WEBPACK FOOTER //
// ./src/components/global/header/FullscreenBtn.js